<div *ngIf="this.spService.featureCollection" style="height: 600px;" id="mapDiv">
</div>